
import Button from '../../../components/base/Button';

export default function GetInvolvedSection() {
  const involvementOptions = [
    {
      title: "Advocacy Volunteer",
      description: "Join our volunteer network to help with campaigns, events, and grassroots organizing efforts.",
      commitment: "2-5 hours/month",
      benefits: ["Training provided", "Networking opportunities", "Certificate of recognition"],
      icon: "ri-hand-heart-line",
      image: "https://public.readdy.ai/ai/img_res/b6db0612d0ce5f16380cceda8fdb4b00.jpg"
    },
    {
      title: "Policy Expert",
      description: "Share your professional expertise to help develop policy positions and review legislative proposals.",
      commitment: "5-10 hours/month",
      benefits: ["Expert committee membership", "Policy briefings", "Professional development"],
      icon: "ri-file-text-line",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20policy%20experts%20reviewing%20legislative%20documents%20and%20research%20papers%20in%20professional%20conference%20room%2C%20pharmacists%20and%20veterinarians%20analyzing%20healthcare%20policy%20proposals%2C%20serious%20academic%20environment&width=300&height=200&seq=policy-expert-001&orientation=landscape"
    },
    {
      title: "Government Relations",
      description: "Build relationships with elected officials and represent CPVA at government meetings and hearings.",
      commitment: "10+ hours/month",
      benefits: ["Leadership training", "Government access", "Speaking opportunities"],
      icon: "ri-government-line",
      image: "https://readdy.ai/api/search-image?query=Professional%20healthcare%20representatives%20meeting%20with%20government%20officials%20in%20Parliament%20building%2C%20formal%20discussion%20about%20healthcare%20policy%2C%20Canadian%20government%20setting%20with%20official%20atmosphere&width=300&height=200&seq=government-relations-001&orientation=landscape"
    },
    {
      title: "Public Speaker",
      description: "Represent CPVA at conferences, media interviews, and community events to advocate for our positions.",
      commitment: "Flexible",
      benefits: ["Media training", "Travel opportunities", "Public recognition"],
      icon: "ri-mic-line",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professional%20giving%20presentation%20at%20medical%20conference%20about%20advocacy%20and%20policy%2C%20speaking%20to%20audience%20of%20healthcare%20workers%2C%20professional%20conference%20setting%20with%20presentation%20screens&width=300&height=200&seq=public-speaker-001&orientation=landscape"
    },
    {
      title: "Digital Advocate",
      description: "Help amplify our message through social media, content creation, and online engagement efforts.",
      commitment: "1-3 hours/week",
      benefits: ["Digital marketing training", "Content creation tools", "Social media reach"],
      icon: "ri-smartphone-line",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20creating%20digital%20content%20for%20advocacy%20campaigns%2C%20using%20laptops%20and%20smartphones%20for%20social%20media%20outreach%2C%20modern%20office%20environment%20with%20creative%20digital%20marketing%20materials&width=300&height=200&seq=digital-advocate-001&orientation=landscape"
    },
    {
      title: "Campaign Coordinator",
      description: "Lead specific advocacy campaigns from planning through execution and evaluation.",
      commitment: "15+ hours/month",
      benefits: ["Leadership experience", "Project management training", "Campaign ownership"],
      icon: "ri-calendar-check-line",
      image: "https://readdy.ai/api/search-image?query=Campaign%20coordinator%20managing%20advocacy%20project%20with%20team%20members%2C%20healthcare%20professionals%20planning%20strategic%20campaign%20activities%2C%20organized%20workspace%20with%20project%20timelines%20and%20strategic%20materials&width=300&height=200&seq=campaign-coordinator-001&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-team-line text-2xl text-purple-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Get Involved in Advocacy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose how you'd like to contribute to advancing healthcare policy and professional advocacy in Canada
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {involvementOptions.map((option, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={option.image} 
                alt={option.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <i className={`${option.icon} text-lg text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {option.title}
                  </h3>
                </div>

                <p className="text-gray-600 mb-4">
                  {option.description}
                </p>

                <div className="mb-4">
                  <span className="text-sm font-medium text-gray-700 block mb-2">Time Commitment:</span>
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                    {option.commitment}
                  </span>
                </div>

                <div className="mb-6">
                  <span className="text-sm font-medium text-gray-700 block mb-2">Benefits:</span>
                  <ul className="space-y-1">
                    {option.benefits.map((benefit, benefitIndex) => (
                      <li key={benefitIndex} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-green-600 mr-2"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>

                <Button className="w-full bg-blue-600 text-white hover:bg-blue-700 whitespace-nowrap">
                  Apply Now
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-900 rounded-lg p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-4">Ready to Make a Difference?</h3>
            <p className="text-xl mb-6">
              Join thousands of healthcare professionals who are actively shaping the future of healthcare policy in Canada.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">5,000+</div>
              <div>Active Advocates</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">25+</div>
              <div>Ongoing Campaigns</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">18</div>
              <div>Legislative Wins</div>
            </div>
          </div>

          <div className="text-center">
            <Button className="bg-white text-blue-900 hover:bg-gray-100 px-8 py-3 text-lg font-medium whitespace-nowrap">
              Start Your Advocacy Journey
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
